import { COLUMN_CATEGORY, COLUMN_COMPANY, COLUMN_CONTACT_NUMBER, COLUMN_DEPARTMENT, COLUMN_EMAIL, COLUMN_END_TIME, COLUMN_FIRST_NAME, COLUMN_LAST_NAME, COLUMN_NAME, COLUMN_READER, COLUMN_SECOND_NAME, COLUMN_START_TIME, COLUMN_SUFFIX, COLUMN_TIME, COLUMN_TITLE, COLUMN_UNIQUE_IDENTIFIER } from "../../constants/column-types";
import { FILTER_COMPANIES, FILTER_DATE, FILTER_DEPARTMENTS, FILTER_READERS, FILTER_SITES, FILTER_TAGHOLDER_TYPE, FILTER_TAGHOLDERS, FILTER_TIME } from "../../constants/filter-types";
import LookupTypes from "../LookupTypes";
import { TableColumn } from "../table/TableColumn";

const StillOnSiteColumn: TableColumn[] = [
    {
        heading: "Title",
        accessor: "title",
        isNumeric: false,
        id: 1,
        sortByName: "mstTitle",
        sortDirection: "asc",
        active: false,
        translationKey: "title",
        columnId: COLUMN_TITLE,
    },
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 2,
        sortByName: "mstDisplayname",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
        lookupName: "mstDisplayname",
        searchOnName: "masterId",
        filterId: FILTER_TAGHOLDERS,
        settingDataName: 'master',
    },
    {
        heading: "First Name",
        accessor: "firstName",
        isNumeric: false,
        id: 3,
        sortByName: "mstFirstname",
        sortDirection: "asc",
        active: false,
        translationKey: "firstName",
        columnId: COLUMN_FIRST_NAME,
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        isNumeric: false,
        id: 4,
        sortByName: "mstLastname",
        sortDirection: "asc",
        active: false,
        translationKey: "lastName",
        columnId: COLUMN_LAST_NAME,
    },
    {
        heading: "Second Name",
        accessor: "middleName",
        isNumeric: false,
        id: 5,
        sortByName: "mstMiddlename",
        sortDirection: "asc",
        active: false,
        translationKey: "secondName",
        columnId: COLUMN_SECOND_NAME,
    },
    {
        heading: "Unique Identifier",
        accessor: "uid",
        isNumeric: true,
        id: 6,
        sortByName: "mstIdnumber",
        sortDirection: "asc",
        active: true,
        translationKey: "uniqueIdentifier",
        columnId: COLUMN_UNIQUE_IDENTIFIER,
    },
    {
        heading: "Contact Number",
        accessor: "mobileNumber",
        isNumeric: false,
        id: 7,
        sortByName: "mobileNumber",
        sortDirection: "asc",
        active: true,
        translationKey: "contactNumber",
        columnId: COLUMN_CONTACT_NUMBER,
    },
    {
        heading: "Department",
        accessor: "deptName",
        isNumeric: false,
        id: 8,
        sortByName: "department.deptName",
        sortDirection: "asc",
        active: true,
        searchOnName: "departmentId",
        lookupName: LookupTypes.department,
        translationKey: "department",
        columnId: COLUMN_DEPARTMENT,
        filterId: FILTER_DEPARTMENTS,
        settingDataName: "department",
    },
    {
        heading: "Company",
        accessor: "compName",
        isNumeric: false,
        id: 9,
        sortByName: "company.compName",
        sortDirection: "asc",
        active: true,
        searchOnName: "companyId",
        lookupName: LookupTypes.company,
        translationKey: "company",
        columnId: COLUMN_COMPANY,
        filterId: FILTER_COMPANIES,
        settingDataName: "company",
    },
    {
        heading: "Category",
        accessor: "category",
        isNumeric: false,
        id: 10,
        active: true,
        translationKey: "category",
        searchOnName: "profileId",
        lookupName: "profile.id",
        columnId: COLUMN_CATEGORY,
        filterId: FILTER_TAGHOLDER_TYPE,
        settingDataName: "profile"
    },
    {
        heading: "First In",
        accessor: "firstIn",
        isNumeric: false,
        id: 11,
        active: true,
        translationKey: "firstIn",
        searchOnName: "firstIn",
        lookupName: "firstIn",
        columnId: COLUMN_START_TIME,
        hideLookup: true
    },
    {
        heading: "Last Seen",
        accessor: "lastSeen",
        isNumeric: false,
        id: 12,
        active: true,
        translationKey: "lastSeen",
        searchOnName: "lastSeen",
        lookupName: "lastSeen",
        columnId: COLUMN_END_TIME, 
        hideLookup: true
    },
    {
        heading: "Last Location",
        accessor: "lastLocation",
        isNumeric: false,
        id: 13,
        active: true,
        translationKey: "lastLocation",
        lookupName: "lastLocation",
        columnId: COLUMN_READER,
        settingDataName: "location",
    },
    {
        heading: "Email",
        accessor: "email",
        isNumeric: false,
        id: 14,
        active: false,
        translationKey: "email",
        columnId: COLUMN_EMAIL,
    },
    {
        heading: "Suffix",
        accessor: "suffix",
        isNumeric: false,
        id: 15,
        sortByName: "mstSuffix",
        active: false,
        translationKey: "suffix",
        columnId: COLUMN_SUFFIX,
    },
    // Bellow columns are for filter only meaning they are not displayed in the table
    {
        heading: "Still On Site",
        accessor: "time",
        isNumeric: false,
        searchOnName: "time",
        sortByName: "time",
        id: 16,
        active: false,
        translationKey: "stillOnSite",
        filterId: FILTER_TIME,
        settingDataName:"time",
        isFilterOnlyColumn: true,
    },
    {
        heading: "Date",
        accessor: "dateOnly",
        isNumeric: false,
        id: 17,
        searchOnName: "dateOnly",
        sortByName: "dateOnly",
        sortDirection: "asc",
        active: false,
        translationKey: "dateOnly",
        filterId: FILTER_DATE,
        settingDataName: "date",
        isFilterOnlyColumn: true,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 18,
        searchOnName: "site.id",
        lookupName: "site",
        sortDirection: "asc",
        active: false,
        translationKey: "site",
        filterId: FILTER_SITES,
        settingDataName: 'site',
        isFilterOnlyColumn: true
    },
    {
        heading: "Exit Points",
        accessor: "exitPoints",
        isNumeric: false,
        id: 19,
        sortByName: "trDevName",
        lookupName: "devName",
        searchOnName: "transacksForTrMasterId.terminal.id",
        sortDirection: "asc",
        active: false,
        isFilterOnlyColumn: true,
        translationKey: "siteExits",
        filterId: FILTER_READERS,
        settingDataName: 'deviceImprox'
    },
]

export default StillOnSiteColumn;